// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__3jqsS","left":"Navbar_left__1ekyM","logo":"Navbar_logo__1KG95","right":"Navbar_right__2I-q-","active":"Navbar_active__1NBcA"};